import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// Import Home Page
import Home from "./page/Home";
// Import FlightSearch
import FlightSearch from "./page/FlightSearch";
import FlightCalendar from "./page/FlightCalendar";
// Import HotelSearch
import HotelSearch from "page/HotelSearch";
// Import Error
import Error from "./page/Error";

// Layout Component
import Header from "./layout/Header";
// import CtaArea from "./layout/CtaArea";
import Footer from "./layout/Footer";
import CopyRight from "./layout/CopyRight";
import FlightBooking from "page/FlightBooking";
import HotelBooking from "page/HotelBooking";
import LoadingOverlay from "component/Common/LoadingOverlay";
import FlightPayment from "page/FlightPayment";
import HotelPayment from "page/HotelPayment";
import FlightConfirmation from "page/FlightBookingConfirmation";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import BackToTop from "component/Common/backToTop";
import HotelDetails from "page/HotelDetails";
import EditMyTicket from "page/EditMyTicket";
import PaymentMethods from "layout/PaymentMethods";
import FlightBookingModification from "page/flightBookingModification";
import ScrollToTop from "component/Common/ScrollToTop";
import Tutoriels from "./page/Tutoriels";
import PaymentLinkPage from "page/PaymentLinkPage";
import ConfirmOrderPage from "page/ConfirmOrderPage";
import PaymentReceiptPage from "page/PaymentReceipt";

const App = () => {
    const { i18n } = useTranslation();
    useEffect(() => {
        const lang = localStorage.getItem("lang");
        if (lang) {
            i18n.changeLanguage(lang);
        } else {
            i18n.changeLanguage("fr");
            localStorage.setItem("lang", "fr");
        }
    }, [i18n]);

    return (
        <div className={i18n.language === "ar" ? "font-cairo" : "font-roboto"}>
            <ScrollToTop/>
            <Header />
            <Routes>
                <Route path="/home" element={<Navigate to="/" />} />
                <Route path="/" element={<Home />} />
                {/* flight */}
                <Route path="/flight-search" element={<FlightSearch />} />
                <Route path="/flight-calendar" element={<FlightCalendar />} />
                <Route path="/flight-booking" element={<FlightBooking />} />
                <Route path="/flight-payment" element={<FlightPayment />} />
                <Route
                    path="/flight-confirmation"
                    element={<FlightConfirmation />}
                />
                <Route
                    path="/confirmPayment/confirmOrder"
                    element={<ConfirmOrderPage />}
                />
                <Route path="/edit-ticket" element={<EditMyTicket />} />
                <Route path="/flight-booking-modification" element={<FlightBookingModification />} />
                {/* hotel */}
                <Route path="/hotel-search" element={<HotelSearch />} />
                <Route path="/hotel-details" element={<HotelDetails />} />
                <Route path="/hotel-booking" element={<HotelBooking />} />
                <Route path="/hotel-payment" element={<HotelPayment />} />
                <Route path="/tutoriels" element={<Tutoriels />} />

                {/* payment link */}
                <Route path="/payment-receipt" element={<PaymentReceiptPage />} />
                <Route path="/payment-link/:uuid" element={<PaymentLinkPage />} />
                <Route path="*" element={<Error />} />
            </Routes>
            <PaymentMethods />
            {/* <CtaArea /> */}
            <Footer />
            <CopyRight />
            <LoadingOverlay />
            <ToastContainer
                position="top-left"
                style={{ zIndex: "9999999999999999999" }}
            />
            <BackToTop />
        </div>
    );
};

export default App;